import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import styles from "./reqSamplePopup.module.css";
import { toast } from "react-toastify";
import api from "../../../utils/api";

const ReqSamplePopup = ({ onClose, id }) => {
  // Formik setup
  const {
    errors,
    values,
    handleChange,
    touched,
    isSubmitting,
    handleBlur,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: {
      quantity: "",
      projectName: "",
      application: "",
      endUser: "",
    },
    validationSchema: Yup.object({
      quantity: Yup.string().required("Quantity is required"),
      projectName: Yup.string().required("Project name is required"),
      application: Yup.string().required("Application is required"),
      endUser: Yup.string().required("End user is required"),
    }),
    onSubmit: async (values) => {
      console.log(values);

      try {
        const datas = {
          id,
          values
        }
        const { data } = await api.sampleRequest(datas)
        if(data){
          onClose()
          toast.success('Sample request sent successfully')
        }
      } catch (err) {
        console.log(err);
        toast.error(err?.response?.data?.message || 'some error occurs')
      }
    },
  });


  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <button className={styles.popupcloseButton} onClick={onClose}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 15L10 10M10 10L5 5M10 10L15 5M10 10L5 15"
              stroke="#333333"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className={styles.popuptitle}>Request for sample</div>

        <form onSubmit={handleSubmit} className={styles.qrForm}>
          <div className={styles.hrLine}></div>
          <div className={styles.qrForminputMain}>
            <div className={styles.qrForminputs}>
              <div className={styles.loginInputGroup}>
                <label>Quantity</label>
                <input
                  type="text"
                  name="quantity"
                  value={values.quantity}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter"
                />
                {touched.quantity && errors.quantity && (
                  <div className={styles.error}>{errors.quantity}</div>
                )}
              </div>
              <div className={styles.loginInputGroup}>
                <label>Project name</label>
                <input
                  type="text"
                  name="projectName"
                  value={values.projectName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter"
                />
                {touched.projectName && errors.projectName && (
                  <div className={styles.error}>{errors.projectName}</div>
                )}
              </div>
            </div>
            <div className={styles.qrForminputs}>
              <div className={styles.loginInputGroup}>
                <label>Application</label>
                <input
                  type="text"
                  name="application"
                  value={values.application}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter"
                />
                {touched.application && errors.application && (
                  <div className={styles.error}>{errors.application}</div>
                )}
              </div>
              <div className={styles.loginInputGroup}>
                <label>End user</label>
                <input
                  type="text"
                  name="endUser"
                  value={values.endUser}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter"
                />
                {touched.endUser && errors.endUser && (
                  <div className={styles.error}>{errors.endUser}</div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.displayFlex}>
            <button
              type="button"
              className={styles.cancelBtn}
              onClick={onClose}
            >
              Back
            </button>
            <button
              type="submit"
              className={styles.submitBtn}
              disabled={isSubmitting}
            >
             {isSubmitting ? 'please wait...' : 'Submit' } 
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReqSamplePopup;
